document.addEventListener('DOMContentLoaded', function (event) {
  updateSearchResultDescription();
});

function updateSearchResultDescription() {
  let searchPluginWrapper = document.querySelector('.flowpack-searchplugin-search');
  if (searchPluginWrapper) {
    let form = searchPluginWrapper.querySelector('form');
    let resultList = searchPluginWrapper.querySelector('ol');
    let resultCount = resultList.querySelectorAll('li').length;
    let resultText =
      resultCount == 0
        ? document.createTextNode('Ihre Suche ergab leider keine Treffer')
        : document.createTextNode('Ihre Suche ergab folgende Treffer');
    let resultTextElement = document.createElement('p');
    resultTextElement.appendChild(resultText);
    searchPluginWrapper.innerHTML = form.outerHTML + resultTextElement.outerHTML + resultList.outerHTML;
  }
}
